/* HeyBear · Product flavour band: running lowercase band in the flavour's accent colour. */
HB.section('product-band', function (root) {
  var tr = root.querySelector('#pBand'), esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var fallback = (root.getAttribute('data-items') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  return HB.pdp.on(function (k, f) {
    if (!f) return;
    var mid = f.facts && f.facts.benefits && f.facts.benefits.length ? f.facts.benefits : fallback;
    var bits = [esc(f.name)].concat(mid.map(esc)).concat(['<em>' + esc(HB.pdp.word(f)) + '</em>']);
    var one = bits.map(function (b) { return '<span>' + b + '</span><span>✦</span>'; }).join('');
    tr.innerHTML = one + one + one;
  });
});
